import apiClient from '@/repositories/apiClient';
import { api } from './api';

export const locationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLocations: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "locations",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.records.map(({ model}) => ({ type: 'Locations', id: model.ID })),
            { type: 'Locations', id: 'LIST' },
          ]
          :
          [{ type: 'Locations', id: 'LIST' }]

      }
    }),
    getLocationsForSelection: build.query({
      query: () => ({
        url: "selections/locations",
        method: "POST",
        body: JSON.stringify({ filters: [], search: '' })
      }),
      transformResponse: (response) => {
        return response.data;
      },
    })
  }),
});

export const getLocationsForSelection = async (search) => {
  return new Promise((resolve, reject) => {
    apiClient.post('/selections/locations', JSON.stringify({ filters: [], search: search }))
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error)
      });
  })
};

export const {
  useGetLocationsQuery,
  useGetLocationsForSelectionQuery,
} = locationsApi;
